<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :return-path="returnPath"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// Author XXL
// Date 2021-07-17 11:36:20

import emCommonEditMixin from "@/mixin/em/common/edit";

export default {
    name: "sithMesStoolPrEditView",
    mixins: [emCommonEditMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        returnPath() {
            return "/sithMes/stool/sithMesStoolOpenPrList";
        },
    }
};
</script>